import React from 'react';

import Spinner from '@uniiverse/library/components/spinner';

import style from './index-module.css';

const LoadingPage: Function = (): React$Element<*> => (
  <div className={style.loadingPage}>
    <Spinner type="dots" size="large" />
  </div>
);

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/loading-page/index.js